import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Categories } from '@/types/categories';
import { getCategoryTrailById } from '@/api/categories';

@Component({
})
export default class CategoryTree extends Vue {
    @Prop({ default: () => [] }) selectedCat!: [string] | []
    @Prop({ default: () => [] }) categories!: Categories
    firstInit = true
    // Expanded nodes, kept in sync with the tree
    openIds: string[] = []
    
    public get m_selectedCat() : [string] | [] {
        return this.selectedCat
    }
    public set m_selectedCat(val) {
        if ( !this.firstInit && (this.selectedCat.length ? this.selectedCat[0] : '') !== (val.length ? val[0] : '') ) this.$emit('change', val)
        this.firstInit = false
    }
    // Expand the path to the selected category; never collapse what the
    // visitor opened
    @Watch('categories', { immediate: true })
    @Watch('selectedCat', { immediate: true })
    revealSelected() {
        const trail = this.selectedCat.length ? getCategoryTrailById(this.selectedCat[0]) : undefined
        if (!trail) return
        const ids = trail.slice(0, -1).map((node) => node.id).filter((id) => !this.openIds.includes(id))
        if (ids.length) this.openIds = this.openIds.concat(ids)
    }
    // The selected category or one of its ancestors
    isOnSelectedTrail(id: string) {
        const trail = this.selectedCat.length ? getCategoryTrailById(this.selectedCat[0]) : undefined
        return !!trail && trail.some((node) => node.id === id)
    }
}